import { Component } from '@angular/core';
import { ScheduledReportRunStatusType } from 'dashboard/enums/scheduled-report-run-status-type.enum';
import { ScheduledReport } from 'dashboard/interfaces/scheduled-report.interface';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { SharedModule } from 'shared/shared.module';

const runStatusTypeTranslationMap = {
    [ScheduledReportRunStatusType.UNKNOWN]: 'dashboard.scheduledReports.table.runStatus.unknown',
    [ScheduledReportRunStatusType.WARNINGS]: 'dashboard.scheduledReports.table.runStatus.warnings',
    [ScheduledReportRunStatusType.SUCCESS]: 'dashboard.scheduledReports.table.runStatus.success',
    [ScheduledReportRunStatusType.RUNNING]: 'dashboard.scheduledReports.table.runStatus.running',
    [ScheduledReportRunStatusType.FAILED]: 'dashboard.scheduledReports.table.runStatus.failed',
    [ScheduledReportRunStatusType.NA]: 'dashboard.scheduledReports.table.runStatus.na',
};

@Component({
    selector: 'app-scheduled-reports-run-status-cell-renderer',
    templateUrl: './scheduled-reports-run-status-cell-renderer.component.html',
    styleUrls: ['./scheduled-reports-run-status-cell-renderer.component.scss'],
    imports: [SharedModule, TooltipDirective],
})
export class ScheduledReportsRunStatusCellRendererComponent extends BaseDataGridCellRenderer {
    public status: string = '';
    public isStatusActionable: boolean = false;
    public messages?: string[];
    public areMessagesOpen: boolean = false;

    constructor() {
        super();
    }

    public onDataChange(): any {
        const data = (this.data as unknown as ScheduledReport).lastRunStatus;

        this.status = runStatusTypeTranslationMap[data.status];
        this.isStatusActionable =
            data.status === ScheduledReportRunStatusType.FAILED || data.status === ScheduledReportRunStatusType.WARNINGS;
        this.messages = [...(data.errors ?? []), ...(data.warnings ?? [])];
    }

    public openMessages(numberOfMessages: number) {
        if (numberOfMessages === 0) {
            return;
        }

        this.areMessagesOpen = true;
    }

    public closeMessages() {
        this.areMessagesOpen = false;
    }
}
